/** @jsxImportSource @emotion/react */
import { ChevronRight } from '@mui/icons-material'
import { Box, Typography, useTheme } from '@mui/material'
import { Link } from 'react-router-dom'
import {
  guideItemBox,
  guideItemTypography,
  guideItemIcon,
  guideItemsContainer,
  guideCardContainer,
} from './GuideItem.style'

export interface GuideItemProps {
  title: string
  path: string
}

export const GuideItem = ({ title, path }: GuideItemProps) => {
  const theme = useTheme()
  return (
    <Link to={path} style={{ textDecoration: 'none' }}>
      <Box css={guideItemBox}>
        <Typography css={guideItemTypography} variant="body1">
          {title}
        </Typography>
        <ChevronRight css={guideItemIcon(theme)} />
      </Box>
    </Link>
  )
}

export const GuideItemsContainer = ({ children }: { children: React.ReactNode }) => {
  return <Box css={guideItemsContainer}>{children}</Box>
}

export const GuideCardContainer = ({ children }: { children: React.ReactNode }) => {
  const theme = useTheme()
  return <Box css={guideCardContainer(theme)}>{children}</Box>
}
